import type { DataItem as JobIdSearchTableDataItem } from '@/components/tables/JobIdSearchTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { getStrCell } from '@/utils/file';
import * as oneTrackingJobHelpers from '@/helpers/trackingJob/oneTrackingJob';

export function getTableItem(
  job: openapi.GetJobSearch_1_200[0],
  isStaff: boolean,
): JobIdSearchTableDataItem {
  const { jobId, jobDate } = oneTrackingJobHelpers.getJobIdAndJobDate(job);
  const mainSuburb = oneTrackingJobHelpers.getMainSuburbName(job);

  return {
    uniqueKey: job.id.toString(),
    jobId,
    jobDate,
    customerCode: isStaff ? getStrCell(job.customer) : undefined,
    driver: isStaff
      ? getStrCell(oneTrackingJobHelpers.getMainDriver(job))
      : undefined,
    reference1: getStrCell(job.ref1),
    ref1Prompt: job.ref1_prompt,
    stopName: getStrCell(oneTrackingJobHelpers.getMainStopName(job)),
    stopNumber: 0, // TODO
    suburb: getStrCell(mainSuburb),
    state: getStrCell(oneTrackingJobHelpers.getMainSuburbState(job)),
    attributes: oneTrackingJobHelpers.getJobAttributes(job),
    serviceCode: '', // TODO
    status: '', // TODO
    isFutile: job.is_futile,
  };
}
